/* Comfort-Fresh product page, v11 (5 Nov 2026). Works on the HTML from sections/cf-pdp.liquid.
   Only swaps text, classes and image sources when an option changes. No timers, no section re-fetch.
   Add to cart: one /cart/add.js request with the free gifts first and the pack last (so the pack is the first
   line in the cart and at checkout), then the theme's own cart:update event re-draws and opens the drawer. */
(function () {
  var root = document.querySelector('[data-cfp]');
  if (!root || root.__cfp) return;
  root.__cfp = true;
  var D;
  try { D = JSON.parse(root.querySelector('[data-cfp-data]').textContent); } catch (e) { return; }
  var V = D.v, P = D.pidx, S = D.sidx;
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function money0(c) { var s = (c / 100).toFixed(2); return '$' + (s.slice(-3) === '.00' ? s.slice(0, -3) : s); }
  function num(v) { return parseInt(String(v || '').split(' ')[0], 10) || 0; }
  function txt(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function sel() { var o = []; $$('[data-cfp-opt]').forEach(function (i) { if (i.checked) o[+i.getAttribute('data-cfp-opt')] = i.value; }); return o; }
  function find(o) {
    for (var k = 0; k < V.length; k++) {
      var v = V[k], ok = true;
      for (var i = 0; i < v[1].length; i++) { if (o[i] !== undefined && v[1][i] !== o[i]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function other(o, i, val) { var c = o.slice(); c[i] = val; return find(c); }

  var CART = null;
  function getCart() {
    if (!CART) CART = fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { CART = null; return { items: [], item_count: 0 }; });
    return CART;
  }
  (window.requestIdleCallback || setTimeout)(function () { getCart(); });

  var insTouched = false, autoDesign = {};
  function insSize() {
    var c = root.querySelector('input[name="cfp-ins-s"]:checked');
    if (insTouched && c) return c.value;
    var sz = S >= 0 ? String(sel()[S] || '') : '';
    return /9[-–]11|^(XS|S|M)$/i.test(sz) ? 'S/M' : 'L/XL';
  }
  function insDesign() { var c = root.querySelector('input[name="cfp-ins-d"]:checked'); return c ? c.value : ''; }
  function insVariant() {
    var size = insSize(), d = insDesign(), list = D.ins.v.filter(function (x) { return x[2] === size && x[3]; });
    if (!list.length) list = D.ins.v.filter(function (x) { return x[3]; });
    if (!list.length) return null;
    if (d) { for (var i = 0; i < list.length; i++) if (list[i][1] === d) return list[i][0]; }
    if (!autoDesign[size]) autoDesign[size] = list[Math.floor(Math.random() * list.length)][0];
    return autoDesign[size];
  }
  function insUpdate(n) {
    var box = $('[data-cfp-ins]'); if (!box) return;
    var msg = $('[data-cfp-insmsg]', box), size = insSize(), d = insDesign();
    if (!insTouched) { $$('input[name="cfp-ins-s"]', box).forEach(function (r) { r.checked = r.value === size; }); }
    $$('input[name="cfp-ins-d"]', box).forEach(function (r) {
      r.disabled = !D.ins.v.some(function (x) { return x[1] === r.value && x[2] === size && x[3]; });
    });
    var h;
    if (n >= 18) {
      box.removeAttribute('data-off');
      h = '<b>Free printed insoles</b>, size ' + size + ': ' + (d ? 'design <b>' + d + '</b>.' : 'we pick a design for you, or choose one.');
    } else {
      box.setAttribute('data-off', '');
      $('[data-cfp-inspanel]', box).hidden = true;
      $('[data-cfp-insopen]', box).setAttribute('aria-expanded', 'false');
      h = '<b>Printed insoles</b> come free with the 18 or 24-pair pack.';
    }
    if (msg.innerHTML !== h) msg.innerHTML = h;
  }

  var mixBox = $('[data-cfp-mix]'), mix = { key: '', counts: {}, colors: [] };
  var CI = -1;
  if (mixBox) { for (var i = 0; i < V.length && CI < 0; i++) for (var j = 0; j < V[i][1].length; j++) if (/mix/i.test(V[i][1][j])) { CI = j; break; } }
  function mixOn(o) { return mixBox && CI >= 0 && /mix/i.test(o[CI] || ''); }
  function mixTotal() { var t = 0; Object.keys(mix.counts).forEach(function (k) { t += mix.counts[k]; }); return t; }
  function mixEven(n) {
    var base = mix.colors.filter(function (c) { return !/white/i.test(c); }); if (!base.length) base = mix.colors;
    mix.counts = {}; mix.colors.forEach(function (c) { mix.counts[c] = 0; });
    var each = Math.floor(n / base.length), rest = n - each * base.length;
    base.forEach(function (c, i) { mix.counts[c] = each + (i < rest ? 1 : 0); });
  }
  function mixRender(n) {
    var rows = $('[data-cfp-mixrows]', mixBox);
    rows.innerHTML = mix.colors.map(function (c) {
      return '<div class="cfp-mx__i" data-c="' + c.replace(/"/g, '&quot;') + '"><b>' + c + '</b><button type="button" data-d="-1" aria-label="One less ' + c + '">−</button><output>' + (mix.counts[c] || 0) + '</output><button type="button" data-d="1" aria-label="One more ' + c + '">+</button></div>';
    }).join('');
    var t = mixTotal(), cnt = $('[data-cfp-mixcount]', mixBox);
    txt(cnt, t + ' of ' + n + ' pairs'); cnt.classList.toggle('is-bad', t !== n);
  }
  function mixUpdate(o, n) {
    if (!mixBox) return;
    var on = mixOn(o); mixBox.hidden = !on; if (!on) return;
    var size = S >= 0 ? o[S] : '', key = size + '|' + n;
    if (key !== mix.key) {
      mix.key = key; mix.colors = [];
      V.forEach(function (v) { var c = v[1][CI]; if ((S < 0 || v[1][S] === size) && !/mix/i.test(c) && mix.colors.indexOf(c) < 0) mix.colors.push(c); });
      mixEven(n); mixRender(n);
    }
  }
  function mixProps(n) {
    var pat = mixBox.getAttribute('data-pattern') || '', size = String(S >= 0 ? sel()[S] : '').replace(/[MY]$/i, '');
    var used = mix.colors.filter(function (c) { return mix.counts[c]; });
    return {
      'Colour mix': used.map(function (c) { return mix.counts[c] + '× ' + c; }).join(' · '),
      'Pick SKUs': used.map(function (c) { return (pat ? pat.replace('{color}', c).replace('{size}', size) : c + ' ' + size) + ' ×' + mix.counts[c]; }).join(' | ')
    };
  }
  if (mixBox) mixBox.addEventListener('click', function (e) {
    var n = num(sel()[P]);
    var b = e.target.closest('button'); if (!b) return;
    if (b.hasAttribute('data-cfp-mixeven')) mixEven(n);
    else if (b.hasAttribute('data-cfp-mixclear')) mix.colors.forEach(function (c) { mix.counts[c] = 0; });
    else if (b.hasAttribute('data-d')) {
      var c = b.closest('[data-c]').getAttribute('data-c'), d = +b.getAttribute('data-d');
      if (d > 0 && mixTotal() >= n) return;
      mix.counts[c] = Math.max(0, (mix.counts[c] || 0) + d);
    }
    mixRender(n);
  });

  var track = $('[data-cfp-track]'), thumbs = $$('[data-cfp-thumbs] button');
  function slides() { return $$('.cfp-g__s', track); }
  function go(i) { var s = slides()[i]; if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
  function curIdx() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
  if (track) {
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; var k = curIdx(); thumbs.forEach(function (t) { var on = +t.getAttribute('data-go') === k; if ((t.getAttribute('aria-current') === 'true') !== on) t.setAttribute('aria-current', on ? 'true' : 'false'); }); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-go')); }); });
    var pv = $('[data-cfp-prev]'), nx = $('[data-cfp-next]');
    if (pv) pv.addEventListener('click', function () { go(Math.max(0, curIdx() - 1)); });
    if (nx) nx.addEventListener('click', function () { go(Math.min(slides().length - 1, curIdx() + 1)); });
  }

  var lastColorKey = null;
  function update() {
    var o = sel(), v = find(o), n = P >= 0 ? num(o[P]) : 0;
    $$('[data-cfp-sel]').forEach(function (s) { txt(s, o[+s.getAttribute('data-cfp-sel')] || ''); });
    $$('.cfp-o__v input[data-cfp-opt]').forEach(function (inp) {
      var alt = other(o, +inp.getAttribute('data-cfp-opt'), inp.value), sp = inp.nextElementSibling;
      if (sp) sp.classList.toggle('is-na', !alt || !alt[4]);
    });
    var btn = $('[data-cfp-atc]');
    if (v) {
      $('[data-cfp-id]').value = v[0];
      txt($('[data-cfp-price]'), money(v[2]));
      var c = $('[data-cfp-cmp]'); if (c) { c.hidden = !(v[3] > v[2]); if (v[3] > v[2]) txt(c, money(v[3])); }
      if (n) { txt($('[data-cfp-pp]'), money(Math.floor(v[2] / n)) + ' a pair'); txt($('[data-cfp-pp2]'), money(Math.floor(v[2] / n)) + ' a pair'); }
      btn.disabled = !v[4]; txt(btn, v[4] ? 'Add to cart · ' + money(v[2]) : 'Sold out');
      if (v[6]) $$('.cfp-vimg').forEach(function (im) { if (im.getAttribute('src') !== v[6]) { im.removeAttribute('srcset'); im.src = v[6]; } });
      try { history.replaceState(history.state, '', location.pathname + '?variant=' + v[0]); } catch (e) {}
      var ck = o.filter(function (x, i) { return i !== P; }).join('|');
      if (lastColorKey !== null && ck !== lastColorKey && v[5] && track && curIdx() > 0) {
        var idx = slides().findIndex(function (s) { return s.getAttribute('data-mid') === String(v[5]); }); if (idx >= 0) go(idx);
      }
      lastColorKey = ck;
    } else { btn.disabled = true; txt(btn, 'Unavailable'); }
    var g = (n >= 12 && D.bag.on ? 1 : 0) + (n >= 18 && D.ins.on ? 1 : 0) + (n >= 24 && D.aid.on ? 1 : 0), ge = $('[data-cfp-gifts]');
    if (ge) { ge.hidden = !g; txt(ge, '+ ' + g + ' free gift' + (g === 1 ? '' : 's')); }
    $$('[data-cfp-pairs]').forEach(function (e) { txt(e, n + ' pairs of socks'); });
    $$('[data-need]').forEach(function (t) {
      var lock = n < +t.getAttribute('data-need'); t.classList.toggle('is-locked', lock);
      var tg = t.querySelector('[data-on]'); if (tg) txt(tg, tg.getAttribute(lock ? 'data-off' : 'data-on'));
    });
    var nd = $('[data-cfp-nudge]'), nh = D.nudge[String(n)];
    if (nd && nh !== undefined) { if (nd.innerHTML !== nh) nd.innerHTML = nh; nd.classList.toggle('is-done', /unlocked|included/i.test(nh)); }
    if (P >= 0) {
      var base = null;
      D.packs.forEach(function (pn) {
        var card = root.querySelector('.cfp-pk__c[data-pack="' + pn + '"]'); if (!card) return;
        var alt = other(o, P, card.querySelector('input').value);
        if (base === null && alt) base = { n: pn, p: alt[2] };
        txt($('[data-cfp-kp]', card), alt ? money(alt[2]) : 'Sold out');
        txt($('[data-cfp-kpp]', card), alt ? money(Math.floor(alt[2] / pn)) + ' / pair' : '');
        var ks = $('[data-cfp-ks]', card); if (ks && alt && base) txt(ks, 'Save ' + money0(Math.floor(base.p * pn / base.n) - alt[2]));
        var tp = root.querySelector('[data-ct-p="' + pn + '"]'), tpp = root.querySelector('[data-ct-pp="' + pn + '"]');
        txt(tp, alt ? money(alt[2]) : '—'); txt(tpp, alt ? money(Math.floor(alt[2] / pn)) + ' / pair' : '');
        $$('[data-ct-col="' + pn + '"]').forEach(function (cell) { cell.classList.toggle('is-sel', pn === n); });
      });
    }
    insUpdate(n);
    mixUpdate(o, n);
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'cfp-ins-s') insTouched = true;
    if (t.hasAttribute('data-cfp-opt') || t.name === 'cfp-ins-s' || t.name === 'cfp-ins-d') update();
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button'); if (!t) return;
    if (t.hasAttribute('data-cfp-insopen')) { var p = $('[data-cfp-inspanel]'); p.hidden = !p.hidden; t.setAttribute('aria-expanded', p.hidden ? 'false' : 'true'); t.textContent = p.hidden ? 'Choose a design' : 'Close'; }
    if (t.getAttribute('data-cfp-open') === 'size') { var d = document.getElementById('cfp-size'); if (d) { d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
    if (t.hasAttribute('data-choose')) pick(+t.getAttribute('data-choose'), true);
  });
  var nudge = $('[data-cfp-nudge]');
  if (nudge) nudge.addEventListener('click', function () { if (!nudge.classList.contains('is-done')) pick(D.packs[D.packs.length - 1], false); });
  function pick(pn, scroll) {
    var card = root.querySelector('.cfp-pk__c[data-pack="' + pn + '"]'); if (!card) return;
    var inp = card.querySelector('input'); if (!inp.checked) { inp.checked = true; update(); }
    if (scroll) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  var busy = false, errEl = $('[data-cfp-err]');
  function err(m) { txt(errEl, m || ''); }
  function sectionIds() { var ids = []; document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) { var s = c.getAttribute('data-section-id'); if (ids.indexOf(s) < 0) ids.push(s); }); return ids; }
  function post(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds().join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok && !j.status, j: j }; }); });
  }
  $('[data-cfp-atc]').addEventListener('click', function () {
    if (busy) return;
    var o = sel(), v = find(o); if (!v || !v[4]) return;
    var n = P >= 0 ? num(o[P]) : 0, mixP = null;
    if (mixOn(o)) { if (mixTotal() !== n) { err('Your mix adds up to ' + mixTotal() + ' of ' + n + ' pairs. Please make it ' + n + '.'); return; } mixP = mixProps(n); }
    err(''); busy = true;
    var btn = this; btn.classList.add('is-busy'); var label = btn.textContent; txt(btn, 'Adding…');
    getCart().then(function (c) {
      var items = [], has = function (id) { return (c.items || []).some(function (i) { return String(i.variant_id) === String(id) && i.properties && i.properties._cf_gift; }); };
      if (D.bag.on && n >= 12 && !has(D.bag.id)) items.push({ id: D.bag.id, quantity: 1, properties: { _cf_gift: 'Free wash bag with your pack', Style: D.bag.sku } });
      if (D.aid.on && n >= 24 && !has(D.aid.id)) items.push({ id: D.aid.id, quantity: 1, properties: { _cf_gift: 'Holiday gift with 24 pairs' } });
      var iv = D.ins.on && n >= 18 ? insVariant() : null;
      if (iv) items.push({ id: iv, quantity: 1, properties: { _cf_gift: 'Included with pack' } });
      var pack = { id: v[0], quantity: 1 }; if (mixP) pack.properties = mixP;
      items.push(pack);
      return post(items).then(function (x) { return x.ok || items.length === 1 ? x : post([pack]).then(function (y) { y.items = [pack]; return y; }); })
        .then(function (x) {
          if (!x.ok) { err(x.j.description || x.j.message || 'Sorry, that could not be added. Please try again.'); return; }
          var added = (x.items || items).reduce(function (a, i) { return a + i.quantity; }, 0), count = (c.item_count || 0) + added;
          CART = null;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: { item_count: count }, sourceId: 'cf-pdp', data: { source: 'cf-pdp', itemCount: count, sections: x.j.sections } } }));
        });
    }).catch(function () { err('Sorry, something went wrong. Please try again.'); })
      .then(function () { busy = false; btn.classList.remove('is-busy'); if (btn.textContent === 'Adding…') txt(btn, label); });
  });

  update();
})();
